import * as React from 'react';
import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Row, Col, FormGroup, Label, CustomInput} from 'reactstrap';
import InputFileUpload from "components/Varios/InputFileUpload.js";

const style = {
    height: '100%',
    //padding: '0px',
};


export default class ModalPDF extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: this.props.isOpen,
            firmaElectronica: true,
            contrasenia: "",
            cambio: "",
        };

        this.ButtonAcept = React.createRef();

        this.onChangeTipoFirma = this.onChangeTipoFirma.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeAcept = this.handleChangeAcept.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    toggle = () => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.onCancel("P") })
        );
    };

    onChangeTipoFirma(tipo) {
        this.setState({
            firmaElectronica: tipo === "E" ? true : false,
        })
    }

    handleChange(event) {
        var contrasenia = event.target.value;
        this.setState(
            { contrasenia: contrasenia },
            (() => { this.props.onChangeInput(contrasenia, "contrasenia") })
        );
    }

    handleChangeAcept(event,firmaElectronica) {
        var botonAceptar = document.getElementById("botonAceptar");
        var botonCancelar = document.getElementById("botonCancelar");
        const i = document.createElement("i");
        i.setAttribute("id", "loadingEnviar")
        i.setAttribute("class", "fa fa-spin fa-spinner")
        botonAceptar.textContent = "Enviando... "
        botonAceptar.insertBefore(i, null)
        botonAceptar.setAttribute("disabled", true)
        botonCancelar.setAttribute("disabled", true)
        
        this.setState(
            { cambio: "" },
            (() => { this.props.onAcept(firmaElectronica ? "E":"F") })
        );
    }

    render() {

        return (
            <div>
                <Modal style={style} isOpen={this.props.isOpen} toggle={this.toggle} className="modal-xl" >
                    <ModalHeader toggle={this.toggle}>{this.props.titulo}</ModalHeader>
                    <ModalBody>
                        
                        {
                            this.props.url != "" ?

                                <div style={{ overflowX: "auto" }} className="row text-center">
                                    <object data={this.props.url} type="application/pdf" width="100%" height={this.props.tipo == "RE" ? "300" : (this.props.tipo == "RD" ? "400" : "400")}>

                                    </object>
                                </div>

                                :
                                null
                            
                        }
                        {
                            this.props.tipo == "RE" || this.props.tipo == "FD" ?
                                <>
                                <Row className="text-center mt-3 mb-3" style={{ textAlign: "center" }}>
                                    <div className="col-md-3">
                                    </div>
                                    <CustomInput
                                        className="col-md-3"
                                        type="radio"
                                        checked={this.state.firmaElectronica}
                                        id="firmaElectronica1"
                                        onChange={() => this.onChangeTipoFirma("E")}
                                        label="Firmar electrónicamente"
                                    />
                                    <CustomInput
                                        className="col-md-3"
                                        type="radio"
                                        id="firmaElectronica2"
                                        checked={!this.state.firmaElectronica}
                                        onChange={() => this.onChangeTipoFirma("M")}
                                        label="Firmar físicamente"
                                    />
                                    {
                                        //<Button color="primary" type="button" className="btn btn-default ml-2" onClick={() => this.onChangeTipoFirma("E")}>Firmar electronicamente</Button>
                                        //<Button color="primary" type="button" className="btn btn-default" onClick={() => this.onChangeTipoFirma("F")} >Firmar fisicamente</Button>
                                    }


                                </Row>

                                    {
                                        this.state.firmaElectronica ?
                                            <Row form>
                                                <Col md={6}>
                                                    <FormGroup>
                                                        <Label for="nombremencion">Certificado*</Label>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.props.onChangeFile}
                                                            name="DOC"
                                                            id="CERT"
                                                            placeholder="Subir firma electrónica"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup>
                                                        <Label for="nombremencion">Contraseña*</Label>
                                                        <Input type="password" name="contrasenia" id="contrasenia" placeholder="" onChange={this.handleChange} value={this.props.valueContrasenia} />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            :
                                            <>
                                                <InputFileUpload
                                                    icon="upload"
                                                    onChange={this.props.onChangeFile}
                                                    name="DOC"
                                                    id="CART"
                                                    placeholder="Subir documento firmado físicamente"
                                                />
                                                <Row className="ml-2 mt-2">
                                                    <span id="muted">
                                                        Esta solicitud se hará efectiva, una vez que se entregue el documento original en la Dirección de Talento Humano 
                                                        <i className="fas fa-info-circle pl-2" aria-hidden="true" style={{ color: "red"}}></i >
                                                    </span>
                                            </Row>
                                            </>

                                }
                                </>
                                :
                                null

                        }

                        
                    </ModalBody>
                    <ModalFooter>
                        {this.props.tipo == "RE" || this.props.tipo == "FD"?
                            <>
                                <Button color="primary" id="botonAceptar" onClick={(event) => this.handleChangeAcept(event,this.state.firmaElectronica)} ref={this.ButtonAcept} >{this.props.textBtn}</Button>{' '}
                                <Button color="secondary" id="botonCancelar" onClick={this.toggle}>Cancelar</Button>
                            </>
                            :
                            <Button color="secondary" onClick={this.toggle}>Cerrar</Button>
                        }
                    </ModalFooter>
                </Modal>
            </div >
        );
    }

}